import { FormField } from '@models/forms/form-field.model';

export interface Form {
  id: string;
  formId: string;
  communityId: string;
  updatedAt: Date;
  createdAt: Date;
  deletedAt: Date;
  name: string;
  description: string;
  parentId: string;

  formFieldset: FormField[];
  type?: FormType;
}
export enum FormType {
  Default = 'DEFAULT',
  Mig = 'MIG',
}
